<template>
  <div>
    <el-row>
      <rabbey-toolbox :call-new="callNewProjectDrawer" :filterables="false">
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-refresh-right"
          style="margin-right: 10px"
          @click="updateTable"
        >
          Refrescar
        </el-button>
        <!-- FILTRO DE AÑOS -->
        <el-tooltip content="Año" placement="top" effect="light">
          <el-select
            v-model="year"
            placeholder="Años"
            class="box-item"
            size="mini"
            @change="handlerYearChange"
            clearable
          >
            <el-option
              v-for="year in yearsForFilter"
              :key="year.value"
              :label="year.label"
              :value="year.value"
            ></el-option>
          </el-select>
        </el-tooltip>

        <!-- FILTRO DE PROYECTOS -->
        <el-tooltip
          content="Proyecto especifico"
          placement="top"
          effect="light"
        >
          <el-select
            v-model="projects"
            placeholder="Todos"
            class="box-item"
            size="mini"
            :width="200"
            :no-data-text="showNoProjectMessage"
            @change="handleProjectChange"
            clearable
          >
            <el-option
              v-for="project in ProjectList"
              :key="project.Code"
              :label="project.Name"
              :value="project"
            ></el-option>
          </el-select>
        </el-tooltip>
        <!-- FILTRO DE COMPAÑIA -->
        <el-tooltip content="Por empresa" placement="top" effect="light">
          <el-select
            v-model="companyFilter"
            class="box-item"
            size="mini"
            clearable
            @change="handleCompanyChange"
          >
            <el-option
              v-for="company in companyList"
              :key="company.value"
              :label="company.label"
              :value="company.value"
            ></el-option>
          </el-select>
        </el-tooltip>

        <div class="mr-5">
          <el-tooltip
            content="Estado de Ejecucion"
            placement="top"
            effect="light"
          >
            <el-select
              v-model="ExecusionState"
              size="mini"
              @change="handleExecusionStateChanges"
            >
              <el-option
                v-for="ExecusionState in ExecusionStates"
                :key="ExecusionState.value"
                :label="ExecusionState.label"
                :value="ExecusionState.value"
              >
              </el-option>
            </el-select>
          </el-tooltip>
        </div>

        <div class="mr-5">
          <el-tooltip content="Estado de vida" placement="top" effect="light">
            <el-select
              v-model="lifeState"
              size="mini"
              @change="handleLifeStateChanges"
            >
              <el-option
                v-for="lifeState in lifeStates"
                :key="lifeState.value"
                :label="lifeState.label"
                :value="lifeState.value"
              >
              </el-option>
            </el-select>
          </el-tooltip>
        </div>

        <!-- SWITCH DE ACTIVO/CERRADO -->
        <!--
        <el-switch
          active-text="Activos"
          inactive-text="Cerrados"
          v-model="projectActive"
          style="margin-right: 10px"
          @change="activeOrInactiveProjects"
        />
        -->
      </rabbey-toolbox>
    </el-row>

    <el-row>
      <el-card>
        <RabbeyTable3
          ref="table_new"
          v-loading="table_new_loading"
          :header-cell-style="{ background: getColorHeader, color: 'white' }"
          :stripe="false"
          :columns="projectTableColumns"
          :data="
            filteredProjectList.length > 0
              ? filteredProjectList
              : TableProjectList
          "
          :actions="actions"
          :row-class-name="tableRowClassName"
          :paginateFromApi="true"
          :paginationApi="pagination"
          @rtable-push-action="actionHandler"
        />
      </el-card>
    </el-row>

    <!-- DRAWER DETALLE -->
    <el-drawer
      title="Detalle del Proyecto"
      :visible.sync="DetailDrawer"
      :before-close="handleCloseDetailDrawer"
      :size="setDetailDrawerSize"
    >
      <el-form style="padding: 20px" label-position="left">
        <el-form-item label="Nombre del Proyecto">{{
          DetailProject
        }}</el-form-item>

        <el-form-item label="Mes: "> {{ DetailMonth }}</el-form-item>

        <!-- TABLA DEL DETALLE -->
        <el-table
          ref="detailTable"
          :data="projectDetailList"
          style="width: 100%; margin-top: 20px"
          @select="handleStatusToggle"
        >
          <el-table-column :minWidth="95" fixed align="center" v-if="isPayment">
            <template slot="header" slot-scope="scope">
              <i class="el-icon-setting" :key="scope.$index"></i>
            </template>
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleDetailCommand">
                <span class="el-dropdown-link">
                  <i class="mdi mdi-menu"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <template v-for="(action, index) in detailProyectActions">
                    <el-dropdown-item
                      :key="index"
                      :command="{
                        index: scope.$index,
                        row: scope.row,
                        column: scope.column,
                        command: action.command
                      }"
                      :icon="action.icon"
                      >{{ action.label }}</el-dropdown-item
                    >
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column
            label="Código Prov."
            prop="ProveedorCode"
            :minWidth="95"
            v-if="isPayment"
          />
          <el-table-column
            label="Nombre Proveedor"
            prop="ProveedorName"
            :minWidth="140"
            v-if="isPayment"
          />
          <el-table-column label="Nota" prop="Description" :minWidth="200" />
          <el-table-column
            label="Fecha"
            prop="PostinDate"
            :minWidth="100"
            :formatter="handlePostinDateFormat"
          />
          <el-table-column
            label="Monto"
            prop="Amount"
            :minWidth="100"
            :formatter="formatMount"
          />

          <el-table-column prop="Excetuted" :width="100" type="selection" />

          <el-table-column align="right">
            <template slot-scope="scope">
              <el-popconfirm
                confirm-button-text="Si"
                cancel-button-text="No"
                icon="el-icon-info"
                icon-color="red"
                title="¿Seguro que quiere eliminar este registro?"
                @confirm="deletePayment(scope.$index, scope.row)"
              >
                <el-button slot="reference" type="danger" size="mini">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-popconfirm>
              <el-button
                slot="reference"
                type="primary"
                size="mini"
                style="margin-left: 3px"
                @click="changeProjectLineDate(scope.$index, scope.row)"
              >
                <i class="el-icon-edit"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item style="float: right">
          <el-button size="mini" @click="closeDetailDrawer">Cerrar</el-button>
          <el-button
            size="mini"
            type="primary"
            v-loading="SaveButtonLoading"
            @click="updateProjectDetailLine"
            v-if="saveButtonVisible"
            >Guardar
          </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- DRAWER CREAR PROYECTO -->
    <el-drawer
      title="Crear Proyecto"
      :visible.sync="newProjectDrawer"
      :before-close="clearForm"
    >
      <el-form
        ref="projectFormCreation"
        style="padding: 20px"
        label-position="top"
        :rules="projectCreationValidator"
        :model="projectFormCreation"
      >
        <el-form-item label="Nombre del Proyecto" prop="projectName">
          <el-input v-model="projectFormCreation.projectName" />
        </el-form-item>

        <el-form-item label="Nota" prop="description">
          <el-input type="textarea" v-model="projectFormCreation.description" />
        </el-form-item>
        <el-form-item>
          <el-button size="mini" @click="closeNewProjectDrawer"
            >Cancelar</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-loading="SaveButtonLoading"
            @click="createNewProject('projectFormCreation')"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- DRAWER AGREGAR INGRESO -->
    <el-drawer
      title="Entrada de Ingreso"
      :visible.sync="incomeDrawer"
      :before-close="clearForm"
    >
      <el-form
        ref="IncomeForm"
        style="padding: 20px"
        label-position="top"
        :rules="IncomeValidator"
        :model="IncomeOrOutcomeForm"
      >
        <el-form-item label="Motivo de Ingreso" prop="Motive">
          <el-input v-model="IncomeOrOutcomeForm.Motive"> </el-input>
        </el-form-item>

        <el-form-item label="Fecha del Ingreso" prop="PostingDate">
          <el-date-picker
            type="date"
            placeholder="Fecha de Ingreso"
            v-model="IncomeOrOutcomeForm.PostingDate"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="Monto" prop="Amount">
          <el-input-number
            v-model="IncomeOrOutcomeForm.Amount"
            :precision="2"
            :step="1.0"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="Moneda" prop="typeMoney">
          <el-select
            v-model="IncomeOrOutcomeForm.currency"
            placeholder="Tipo de moneda"
            size="mini"
          >
            <el-option
              v-for="item in CurrencyList"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Nota" prop="Description">
          <el-input type="textarea" v-model="IncomeOrOutcomeForm.Description">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" @click="addIncomeCloseDrawer"
            >Cancelar</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-loading="SaveButtonLoading"
            @click="addIncomeToProject('IncomeForm')"
            >Agregar Ingreso</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- DRAWER AGREGAR PAGO -->
    <el-drawer
      title="Registro de Pagos"
      :visible.sync="paymentDrawer"
      size="50%"
      :before-close="clearForm"
    >
      <el-form
        ref="OutcomeForm"
        style="padding: 20px"
        label-position="top"
        :rules="OutcomeValidator"
        :model="IncomeOrOutcomeForm"
      >
        <el-form-item label="Proveedor" prop="ProveedorName">
          <el-row :gutter="20">
            <el-col :span="18">
              <el-input
                v-model="IncomeOrOutcomeForm.ProveedorName"
                :disabled="true"
              >
              </el-input>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" size="mini" @click="getAllProviders"
                >Buscar Proveedor</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="Fecha del Pago" prop="PostingDate">
              <el-date-picker
                type="date"
                placeholder="Fecha del Pago"
                v-model="IncomeOrOutcomeForm.PostingDate"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="Nota" prop="Description">
              <el-input v-model="IncomeOrOutcomeForm.Description"> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="Monto" prop="Amount">
              <el-input-number
                v-model="IncomeOrOutcomeForm.Amount"
                :precision="2"
                :step="1.0"
              ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item>
              <el-button
                type="primary"
                size="mini"
                @click="AddNewPayment('OutcomeForm')"
                >Agregar Pago</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>

        <el-table :data="PaymentList" style="width: 100%">
          <el-table-column
            label="Fecha de Pago"
            prop="PostinDate"
            :formatter="handlePostinDateFormat"
            :minWidth="140"
          />
          <el-table-column label="Nota" prop="Description" :minWidth="140" />
          <el-table-column label="Monto" prop="Amount" :minWidth="140" />

          <el-table-column align="right">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="handleRemovePayment(scope.$index, scope.row)"
              >
                <i class="el-icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item>
          <el-button size="mini" @click="closePaymentDrawer"
            >Cancelar</el-button
          >
          <el-button
            size="mini"
            type="primary"
            v-loading="SaveButtonLoading"
            @click="addPaymentToProject"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <!--Dialogo Nueva soicitud Interna-->
    <NewFormRequest ref="NewFormRequest" :ResquestObject="PaymentResquest" />

    <!-- DIALOG DE CONFIRMACIÓN DE ELIMINACIÓN  -->
    <el-dialog
      :center="true"
      title="Confirmación"
      :visible.sync="confirmationDialog"
      width="25%"
    >
      <span
        >¿Seguro que desea eliminar TODOS los registros de este proyecto?</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleCloseConfirmationDialog"
          >Cancelar</el-button
        >
        <el-button size="mini" type="danger" @click="deleteProject"
          >Si, Eliminar <i class="el-icon-delete-solid"></i>
        </el-button>
      </span>
    </el-dialog>

    <!-- DIALOG DE SELECCIÓN DE PROVEEDOR  -->
    <el-dialog
      title="Listado de Proveedores"
      :visible.sync="providersDialog"
      :before-close="handleCloseProviderDialog"
      width="30%"
    >
      <rabbey-toolbox
        ref="providerToolbox"
        :filterables="true"
        @filter-search="handleSearchProvider"
      />
      <el-table
        :data="getProviderListData"
        style="width: 100%"
        v-loading="providersDialogLoading"
      >
        <el-table-column label="Código" prop="Code"> </el-table-column>
        <el-table-column label="Nombre" prop="Name"> </el-table-column>
        <el-table-column align="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleSelectedProvider(scope.$index, scope.row)"
            >
              Seleccionar
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- DIALOG DE CAMBIO DE FECHA  -->
    <el-dialog
      :title="`Editar Ingreso o Egreso`"
      :visible.sync="changeDateDiaglog"
      width="30%"
    >
      <!-- :before-close="handleCloseProviderDialog" -->
      <el-form>
        <el-form-item label="Nota">
          <el-input disabled v-model="updatedLine.Description" />
        </el-form-item>

        <el-form-item label="Monto">
          <el-input v-model="updatedLine.Amount" />
        </el-form-item>

        <el-form-item label="Nueva Fecha">
          <el-date-picker
            type="date"
            placeholder="Nueva Fecha de Ingreso"
            v-model="updatedLine.PostinDate"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        v-loading="SaveButtonLoading"
        @click="updateLine"
      >
        Guardar Cambios
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import CashFlowHyperlink from "@/components/functionals/CashFlowHyperlink.vue";
import { formatDate } from "@/utils";
import NewFormRequest from "@/components/requests/NewRequestForm.vue";

export default {
  name: "Project",
  components: {
    RabbeyTable3,
    NewFormRequest
  },
  data() {
    return {
      newProjectDrawer: false,
      incomeDrawer: false,
      paymentDrawer: false,
      Recurtion: 0,
      pagination: {
        currentPage: 1,
        pageSize: 100,
        total: this.getTotalofItems
      },
      totalItems: 0,
      lifeState: 1,
      lifeStates: [
        {
          label: "Todos",
          value: 3
        },
        {
          label: "Activos",
          value: 1
        },
        {
          label: "Inactivos",
          value: 0
        }
      ],
      ExecusionState: 3,
      ExecusionStates: [
        {
          label: "Todos",
          value: 3
        },
        {
          label: "Ejecutados",
          value: 1
        },
        {
          label: "No Ejecutados",
          value: 0
        }
      ],
      year: new Date().getFullYear(),
      table_new_loading: false,

      //Variables de Pagos
      confirmationDialog: false,
      PaymentList: [],
      PaymentResquest: {
        DirectionId: 0,
        ResquestTypeId: 0
      },

      //Variables de Filtro de Proveedores
      providersList: [],
      filteredProvidersList: [],
      providersDialog: false,
      providersDialogLoading: false,

      //Variables del Filtro de Proyectos
      companyFilter: "ALL",
      ProjectList: [],
      TableProjectList: [],

      //Cambio de Fecha
      changeDateDiaglog: false,
      updatedLine: {},

      //Filtro de Proyectos
      projects: "",
      projectsCode: "",
      filteredProjectList: [],

      //Creación de Proyecto
      projectFormCreation: {
        projectName: "",
        description: ""
      },
      SaveButtonLoading: false,

      //FORMULARIO
      IncomeOrOutcomeForm: {
        Motive: "",
        ProjectId: null,
        Type: null,
        Amount: 0,
        PostingDate: "",
        Description: "",
        Excetuted: "",
        UserName: "",
        ProveedorCode: null,
        ProveedorName: null,
        currency: "DOP"
      },

      //DETALLE DE PROYECTOS POR MES
      DetailDrawer: false,
      projectDetailList: [],
      updateProjectDetailList: [],
      DetailMonth: "",
      DetailProject: "",
      ChangeStatusHeader: true,
      saveButtonVisible: false,
      projectActive: true,

      //ACCIONES DE LA TABLA
      actions: [
        {
          icon: "el-icon-money",
          label: "Agregar Ingreso",
          command: "add-income",
          condition: (row) => row.TypeOf == "INGRESOS"
        },
        {
          icon: "el-icon-bank-card",
          label: "Agregar Pago",
          command: "add-payment",
          condition: (row) => row.TypeOf == "EGRESOS"
        },
        /*
        {
          icon: "el-icon-delete",
          label: "Eliminar Registros",
          command: "delete",
          condition: (row) => row.TypeOf && row.TypeOf != "Title"
        },
        */
        {
          icon: "el-icon-close",
          label: "Inactivar Projecto",
          command: "Inactivate",
          condition: (row) =>
            row.TypeOf && row.TypeOf != "Title" && row.Visible == true
        },
        {
          icon: "el-icon-check",
          label: "Activar Projecto",
          command: "Activate",
          condition: (row) =>
            row.TypeOf && row.TypeOf != "Title" && row.Visible == false
        }
      ],

      //COLUMNAS DE LAS TABLAS
      projectTableColumns: [
        {
          prop: "Code",
          label: "Contrato",
          minWidth: 90
        },
        {
          prop: "Name",
          label: "Proyecto",
          minWidth: 200
        },
        {
          prop: "January",
          label: "Enero",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
          // fixed: true,
        },
        {
          prop: "Febraury",
          label: "Febrero",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "August",
          label: "Agosto",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "September",
          label: "Septiembre",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "October",
          label: "Octubre",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "November",
          label: "Noviembre",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "December",
          label: "Diciembre",
          minWidth: 95,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        },
        {
          prop: "SubTotal",
          label: "Totales",
          minWidth: 110,
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenDetailDrawer
          }
        }
      ],

      //ACCIONES DEL DETALLE DEL PROJECTO
      detailProyectActions: [
        {
          icon: "el-icon-s-ticket",
          label: "Activar Solicitud de Pago",
          command: "activate-internal-request"
          /*
          condition: (row) =>
            row.TypeOf && row.TypeOf != "Title" && row.Visible == true
          */
        }
      ],

      //VALIDACIONES DE FORMULARIOS
      projectCreationValidator: {
        projectName: [
          {
            required: true,
            trigger: "blur",
            message: "Por favor colocarle un nombre al proyecto."
          }
        ],
        description: [
          {
            required: true,
            trigger: "blur",
            message: "Por favor colocarle una descripción al proyecto."
          }
        ]
      },

      IncomeValidator: {
        Motive: [
          {
            required: true,
            trigger: "blur",
            message: "El Motivo es requerido."
          }
        ],
        PostingDate: [
          {
            required: true,
            trigger: "blur",
            message: "La fecha del Ingreso es requerida."
          }
        ],
        Description: [
          {
            required: true,
            trigger: "blur",
            message: "La Nota del Ingreso es requerida."
          }
        ]
      },

      OutcomeValidator: {
        ProveedorName: [
          {
            required: true,
            trigger: "blur",
            message: "Debe seleccionar un Proveedor."
          }
        ],
        PostingDate: [
          {
            required: true,
            trigger: "blur",
            message: "La fecha del Pago es requerida."
          }
        ],
        Description: [
          {
            required: true,
            trigger: "blur",
            message: "La Nota del pago es requerida."
          }
        ]
      },
      CurrencyList: [
        {
          label: "DOP"
        },
        {
          label: "USD"
        }
      ]
    };
  },
  created() {
    this.getAllProjects();
  },
  methods: {
    //DRAWERS
    callNewProjectDrawer() {
      this.newProjectDrawer = true;
    },

    closeNewProjectDrawer() {
      this.newProjectDrawer = false;
      this.projectFormCreation.projectName = "";
      this.projectFormCreation.description = "";
    },

    closePaymentDrawer() {
      this.paymentDrawer = false;
      this.PaymentList = [];
      this.IncomeOrOutcomeForm.ProveedorCode = "";
      this.IncomeOrOutcomeForm.ProveedorName = "";
    },

    addIncomeCloseDrawer() {
      this.incomeDrawer = false;
    },

    closeDetailDrawer() {
      this.DetailDrawer = false;
      this.saveButtonVisible = false;
      this.saveButtonVisible = false;
      this.projectDetailList = [];
      this.DetailProject = "";
      this.DetailMonth = "";
    },

    //DIVISIONES DE LA TABLA
    tableRowClassName({ row }) {
      //console.log("tableRowClassName row: ",row);
      if (row.TypeOf == null) {
        if (row.Name == "Disponibilidad inicio de mes") {
          return "initial-Balance-Row";
        } else if (row.Name == "Disponible") {
          return "available-Balance-Row";
        } else if (row.Name == "Utilidad Ingresos") {
          return "incoming-utility-Row";
        }
        switch (this.currentCompany) {
          case "TB":
            return "total-row-tbs";
          case "MTR":
            return "total-row-mtr";
          case "RB":
            return "total-row-rb";
        }
      } else if (row.TypeOf == "Title") {
        switch (this.currentCompany) {
          case "TB":
            return "title-row-tbs";
          case "MTR":
            return "title-row-mtr";
          case "RB":
            return "title-row-rb";
        }
      }
      return "";
    },

    //ACTIONS
    actionHandler(action) {
      //console.log("action: ", action);
      const row = action.row;
      this.IncomeOrOutcomeForm.ProjectId = row.Id;
      switch (action.command) {
        case "add-income": {
          this.IncomeOrOutcomeForm.Type = 1;
          this.incomeDrawer = true;
          break;
        }
        case "add-payment": {
          this.IncomeOrOutcomeForm.Type = 0;
          this.paymentDrawer = true;
          break;
        }
        case "delete": {
          this.confirmationDialog = true;
          break;
        }
        case "Inactivate": {
          this.InactivateOrActivateProyect(action.row, false);
          break;
        }
        case "Activate": {
          this.InactivateOrActivateProyect(action.row, true);
          break;
        }
      }
    },

    //EVENTS
    AddNewPayment(validation) {
      this.$refs[validation].validate((valid) => {
        if (valid) {
          this.PaymentList.push({
            ProyectID: this.IncomeOrOutcomeForm.ProjectId,
            Type: this.IncomeOrOutcomeForm.Type,
            Amount: this.IncomeOrOutcomeForm.Amount,
            PostinDate: this.IncomeOrOutcomeForm.PostingDate,
            Description: this.IncomeOrOutcomeForm.Description,
            Excetuted: false,
            UserName: this.currentUser,
            ProveedorCode: this.IncomeOrOutcomeForm.ProveedorCode,
            ProveedorName: this.IncomeOrOutcomeForm.ProveedorName
          });
          this.clearPaymentData();
        }
      });
    },

    clearPaymentData() {
      this.IncomeOrOutcomeForm.PostingDate = "";
      this.IncomeOrOutcomeForm.Amount = "";
      this.IncomeOrOutcomeForm.Description = "";
    },

    //HANDLERS
    handlerYearChange(year) {
      this.year = year;
      this.getAllProjects();
    },
    handleCompanyChange(company) {
      if (company) {
        this.companyFilter = company;
        this.getProjectFilterData();
        this.getAllProjects();
      } else {
        this.companyFilter = "ALL";
        this.ProjectList = [];
        this.getAllProjects();
      }
    },
    handleProjectChange(filterProject) {
      //console.log("selected proyect: ", filterProject);
      this.projects = filterProject.Name;
      this.projectsCode = filterProject.Code;
      this.filteredProjectList = [];
      /*
      if (filterProject ) {
      */
      if (this.Recurtion < 1) {
        // se utiliza la variable recursion para evitar que el metodo entra en bucle, ya que llama al metodo getAllProjects y el mismo al final vuelve a lllamar handleProjectChange
        this.getAllProjects();
      }
      this.Recurtion = 0;
      /*
        let foundProject = this.TableProjectList.filter(
          (project) =>
            project.Code == filterProject.Code || project.TypeOf == "Title"
        );
        this.filteredProjectList = foundProject;
        */
      /*
      } else {
        this.filteredProjectList = [];
      }*/
    },
    handleSearchProvider(search) {
      this.filteredProvidersList = this.providersList.filter((provider) =>
        provider.Name.toLowerCase().includes(search.toLowerCase())
      );
    },
    handleCloseConfirmationDialog() {
      this.confirmationDialog = false;
    },
    handleCloseProviderDialog() {
      this.providersDialog = false;
    },
    handleSelectedProvider(index, row) {
      this.IncomeOrOutcomeForm.ProveedorName = row.Name;
      this.IncomeOrOutcomeForm.ProveedorCode = row.Code;
      this.providersDialog = false;
    },
    handleRemovePayment(index) {
      this.PaymentList.splice(index, 1);
    },
    handlePostinDateFormat(row) {
      return formatDate(row.PostinDate, "DD/MM/YYYY");
    },
    handleStatusToggle(selection, row) {
      this.saveButtonVisible = true;
      row.Excetuted = row.Excetuted == false ? true : false;
    },
    handleCloseDetailDrawer() {
      this.projectDetailList = [];
      this.DetailDrawer = false;
    },

    //API CALLS
    getAllProjects() {
      //Retorna todos los proyectos de la tabla Proyects de Magynet
      const params = {
        params: {
          CompanyCode: this.companyFilter,
          Year: this.year,
          IsActive: this.projectActive,
          lifeState: this.lifeState,
          ExecusionState: this.ExecusionState,
          ProyectCode: this.projectsCode
        }
      };
      this.table_new_loading = true;
      this.$http
        .get(`/api/Proyects`, params)
        .then((resp) => {
          //console.log("resp proj antes filtro: ", resp.data);
          this.TableProjectList = resp.data;
          //console.log("resp proj: ", this.TableProjectList);
          const foundItem = this.TableProjectList.find(
            (project) => project.Name == "Total de Ingresos"
          );
          const initialBalance = this.TableProjectList.find(
            (project) => project.Name == "Disponibilidad inicio de mes"
          );
          const initialBalanceIndex =
            this.TableProjectList.indexOf(initialBalance);
          this.TableProjectList.splice(initialBalanceIndex + 1, 0, {
            Name: "INGRESOS",
            TypeOf: "Title"
          });
          const index = this.TableProjectList.indexOf(foundItem);
          this.TableProjectList.splice(index + 1, 0, {
            Name: "EGRESOS",
            TypeOf: "Title"
          });
          // console.log("resp proj then: ", this.TableProjectList);
        })
        .finally(() => {
          this.table_new_loading = false;
          if (this.projects) {
            let projectCriteria = {
              Name: this.projects,
              Code: this.projectsCode
            };
            this.Recurtion++;
            this.handleProjectChange(projectCriteria);
          }
        });
    },

    updateTable() {
      this.table_new_loading = true;
      this.$http
        .post("/api/Proyects/RefreshTable")
        .then(() => {
          this.getAllProjects();
        })
        .catch(() => {
          this.table_new_loading = false;
        });
    },

    getProjectFilterData() {
      //Retorna todos los proyectos de navition para colocarlos en el filtro
      this.$http
        .get(
          `/api/Proyects/GetAllProjectFromNavision?CompanyCode=${this.companyFilter}`
        )
        .then((resp) => {
          this.ProjectList = resp.data;
        });
    },

    createNewProject(validation) {
      //Crear un nuevo Proyecto
      this.$refs[validation].validate((valid) => {
        if (valid) {
          this.SaveButtonLoading = true;
          this.$http
            .post("/api/Proyects/AddProyect", {
              Name: this.projectFormCreation.projectName,
              Description: this.projectFormCreation.description,
              CompanyCode: this.currentCompany,
              Year: new Date().getFullYear()
            })
            .finally(() => {
              this.SaveButtonLoading = false;
              this.closeNewProjectDrawer();
              this.getAllProjects();
            });
        }
      });
    },

    addIncomeToProject(validation) {
      //Crear un ingreso a un proyecto
      this.$refs[validation].validate((valid) => {
        if (valid) {
          console.log(this.IncomeOrOutcomeForm.currency);
          let ItemsDtoArray = [];
          ItemsDtoArray.push({
            Motive: this.IncomeOrOutcomeForm.Motive,
            // Date: new Date(),
            ProyectID: this.IncomeOrOutcomeForm.ProjectId,
            Type: this.IncomeOrOutcomeForm.Type,
            Amount: this.IncomeOrOutcomeForm.Amount,
            PostinDate: this.IncomeOrOutcomeForm.PostingDate,
            Description: this.IncomeOrOutcomeForm.Description,
            Excetuted: false,
            UserName: this.currentUser,
            ProveedorCode: this.IncomeOrOutcomeForm.ProveedorCode,
            ProveedorName: this.IncomeOrOutcomeForm.ProveedorName,
            Currency: this.IncomeOrOutcomeForm.currency
          });
          this.SaveButtonLoading = true;
          this.$http
            .post("/api/Proyects/AddItemsProyect", ItemsDtoArray)
            .finally(() => {
              this.SaveButtonLoading = false;
              this.incomeDrawer = false;
              this.getAllProjects();
              this.clearForm();
            });
        }
      });
    },
    deleteProject() {
      //Elimina TODAS las entregas de ese proyecto.
      this.$http
        .delete(
          `/api/Proyects/DeleteLine?Proyectid=${this.IncomeOrOutcomeForm.ProjectId}`
        )
        .finally(() => {
          this.confirmationDialog = false;
          this.getAllProjects();
          let notClose = true;
          this.clearForm(notClose);
        });
    },

    getAllProviders() {
      //Obtiene todos los proveedores según la compañía
      this.providersDialog = true;
      this.providersDialogLoading = true;
      this.$http
        .get(`/api/Proyects/GetAllProveedor?CompanyCode=${this.currentCompany}`)
        .then((resp) => {
          this.providersList = resp.data;
        })
        .finally(() => {
          this.providersDialogLoading = false;
        });
    },

    addPaymentToProject() {
      //Agrega un listado de pagos a un proyecto en específico.
      if (this.PaymentList.length > 0) {
        this.SaveButtonLoading = true;
        this.$http
          .post("/api/Proyects/AddItemsProyect", this.PaymentList)
          .finally(() => {
            this.SaveButtonLoading = false;
            this.paymentDrawer = false;
            this.PaymentList = [];
            this.getAllProjects();
            this.clearForm();
          });
      } else {
        this.$message({
          type: "error",
          message: "Favor de introducir al menos un pago "
        });
      }
    },

    OpenDetailDrawer(row, column) {
      //Abre el detalle por mes de los proyectos y retorna todas las lineas de este.
      this.DetailDrawer = true;
      if (this.ChangeStatusHeader) {
        setTimeout(() => {
          this.changetableHeader();
        }, 100);
      }
      let Id = row.Id;
      let type = row.TypeOf == "INGRESOS" ? 1 : 0;
      let month = this.getMonthNumber(column);

      this.DetailProject = row.Name;
      this.DetailMonth = this.translateMonth(column);

      this.$http
        .get(
          `/api/Proyects/GetLines?Proyectid=${Id}&Type=${type}&Month=${month}`
        )
        .then((resp) => {
          this.projectDetailList = resp.data;
        })
        .finally(() => {
          this.projectDetailList.forEach((projectLine) => {
            if (projectLine.Excetuted) {
              this.$refs.detailTable.toggleRowSelection(projectLine, true);
            }
          });
        });
    },

    deletePayment(index, row) {
      //Elimina un pago específico de un proyecto.
      this.$http
        .delete(
          `/api/Proyects/DeleteLine?Proyectid=${row.CurrentProyectID}&ID=${row.Id}`
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.projectDetailList.splice(index, 1);
            this.getAllProjects();
          } else {
            this.$message({
              type: "error",
              message: "Error al eliminar registro"
            });
          }
        });
    },

    changeProjectLineDate(index, row) {
      this.updatedLine = row;
      this.changeDateDiaglog = true;
    },

    updateLine() {
      let projectLine = [];
      projectLine.push(this.updatedLine);
      this.SaveButtonLoading = true;
      this.$http
        .put("/api/Proyects/UpdateLine", projectLine)
        .then((resp) => {
          if (resp.status == 200) {
            this.changeDateDiaglog = false;
            this.DetailDrawer = false;
            this.getAllProjects();
          } else {
            this.$message({
              type: "error",
              message: "Error al actualizar registro"
            });
          }
        })
        .finally(() => {
          this.SaveButtonLoading = false;
        });
    },

    updateProjectDetailLine() {
      //Actualiza la data de una linea de un proyecto.
      this.SaveButtonLoading = true;
      this.$http
        .put("/api/Proyects/UpdateLine", this.projectDetailList)
        .then((resp) => {
          if (resp.status == 200) {
            this.DetailDrawer = false;
            this.getAllProjects();
          } else {
            this.$message({
              type: "error",
              message: "Error al actualizar registro"
            });
          }
        })
        .finally(() => {
          this.SaveButtonLoading = false;
        });
    },

    //HELPERS
    clearForm(paymentDelete) {
      //Simplemente limpia el formulario.
      this.projectFormCreation.projectName = "";
      this.projectFormCreation.description = "";
      this.IncomeOrOutcomeForm.Motive = "";
      this.IncomeOrOutcomeForm.ProjectId = "";
      this.IncomeOrOutcomeForm.Type = "";
      this.IncomeOrOutcomeForm.Amount = "";
      this.IncomeOrOutcomeForm.PostingDate = "";
      this.IncomeOrOutcomeForm.Description = "";
      this.IncomeOrOutcomeForm.ProveedorCode = "";
      this.IncomeOrOutcomeForm.ProveedorName = "";
      this.Excetuted = "";
      this.PaymentList = [];

      this.newProjectDrawer = false;
      this.incomeDrawer = false;
      if (paymentDelete) {
        this.paymentDrawer = false;
      }
    },

    getMonthNumber(month) {
      switch (month) {
        case "January":
          return 1;
        case "Febraury":
          return 2;
        case "March":
          return 3;
        case "April":
          return 4;
        case "May":
          return 5;
        case "June":
          return 6;
        case "July":
          return 7;
        case "August":
          return 8;
        case "September":
          return 9;
        case "October":
          return 10;
        case "November":
          return 11;
        case "December":
          return 12;
      }
    },

    translateMonth(month) {
      switch (month) {
        case "January":
          return "Enero";
        case "Febraury":
          return "Febrero";
        case "March":
          return "Marzo";
        case "April":
          return "Abril";
        case "May":
          return "Mayo";
        case "June":
          return "Junio";
        case "July":
          return "Julio";
        case "August":
          return "Agosto";
        case "September":
          return "Septiembre";
        case "October":
          return "Octubre";
        case "November":
          return "Noviembre";
        case "December":
          return "Diciembre";
      }
    },

    changetableHeader() {
      //Este método simplemente cambia el label de la columna que tiene checkboxs en el detalle de los meses. Le pone el label de 'Ejecutado' en lugar del que element coloca.
      let html = document.getElementsByClassName("el-checkbox");
      let htmlHeader = html[0];
      if (htmlHeader) {
        htmlHeader.classList.remove("el-checkbox");
        htmlHeader.innerHTML = "Ejecutado";
      }
      this.ChangeStatusHeader = false;
    },

    formatMount(mount) {
      const formatter = new Intl.NumberFormat("es-DO", {
        stlye: "currency",
        currency: "DOP"
      });
      return formatter.format(mount.Amount);
    },

    async InactivateOrActivateProyect(row, isActive) {
      const params = {
        ProyectID: row.Id,
        ProyectCode: row.Code,
        CompanyCode: row.CompanyCode,
        IsActive: isActive
      };
      this.$http
        .put("/api/Proyects/InactivateOrActivateProyect", params)
        .then((resp) => {
          resp;
          //console.log(resp);
        })
        .catch((err) => {
          console.error("Error al hacer update al status del project: ", err);
        })
        .finally(() => {
          this.getAllProjects();
        });
    },
    activeOrInactiveProjects() {
      this.getAllProjects();
    },
    handleLifeStateChanges() {
      this.getAllProjects();
    },
    handleExecusionStateChanges() {
      this.getAllProjects();
    },
    handleDetailCommand(action) {
      //console.log("action: ", action)

      switch (action.command) {
        case "activate-internal-request": {
          this.PaymentResquest.DirectionId = 28;
          this.PaymentResquest.ResquestTypeId = 224;
          this.$refs.NewFormRequest.drawer = true;

          break;
        }
        default: {
          break;
        }
      }
    }
  },
  computed: {
    getTotalofItems() {
      return this.TableProjectList.length;
    },
    showNoProjectMessage() {
      if (this.companyFilter == "ALL") {
        return "Primero debe seleccionar una compañía";
      } else if (this.TableProjectList.length <= 4) {
        //Debe ser menor que 4 porque el TableProjectList siempre traerá dos filas con las titulos y dos con los totales
        return "Esta compañía no tiene proyectos";
      } else {
        return "";
      }
    },
    yearsForFilter() {
      const lowLevel = 2014;
      const currentYear = new Date().getFullYear() + 5; //se suman 5 para mostrar 5 años en el futuro
      let Years = [];
      for (var i = lowLevel; i <= currentYear; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    },
    companyList() {
      return [
        {
          label: "Consolidado",
          value: "ALL"
        },
        {
          label: "Rabbey",
          value: "RB"
        },
        {
          label: "Tennos Business",
          value: "TB"
        },
        {
          label: "Magytrack",
          value: "MTR"
        },
        {
          label: "Magycorp SA",
          value: "SA"
        },
        {
          label: "Magycorp Technology",
          value: "MTECH"
        }
      ];
    },
    getProviderListData() {
      if (this.filteredProvidersList.length) {
        return this.filteredProvidersList;
      } else {
        return this.providersList;
      }
    },
    getColorHeader() {
      switch (this.currentCompany) {
        case "TB":
          return "#3a93ce";
        case "MTR":
          return "#3ccfc1";
        case "RB":
          return "#10589b";
      }
      return "#ffffff";
    },
    isPayment() {
      if (
        this.projectDetailList.length > 0 &&
        this.projectDetailList[0].Type == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    setDetailDrawerSize() {
      if (
        this.projectDetailList.length > 0 &&
        this.projectDetailList[0].Type == 0
      ) {
        return "65%";
      } else {
        return "50%";
      }
    }
  }
};
</script>

<style>
.el-table .total-row-tbs {
  background: #3a93ce;
  color: white;
  font-weight: bold;
}

.el-table .total-row-mtr {
  background: #3ccfc1;
  color: white;
  font-weight: bold;
}

.el-table .total-row-rb {
  background: #10589b;
  color: white;
  font-weight: bold;
}

.el-table .title-row-tbs {
  background: #9dd2f5;
  color: black;
  font-weight: bold;
}

.el-table .title-row-mtr {
  background: #b8f5ef;
  color: black;
  font-weight: bold;
}

.el-table .title-row-rb {
  background: #76a2f5;
  color: black;
  font-weight: bold;
}

.el-table .initial-Balance-Row {
  background: #8bb9f5;
  color: rgb(3, 0, 155);
  font-weight: bold;
}
.el-table .available-Balance-Row {
  background: #8bb9f5;
  color: rgb(3, 0, 155);
  font-weight: bold;
}
.el-table .incoming-utility-Row {
  background: #63a7d4;
  color: white;
  font-weight: bold;
}
</style>
